<template>
    <b-card no-body>
        <v-table    ref="table"
                    search  
                    with-items
                    :items="c_items"
                    selectable
                    pagination="client"
                    v-on:select="selecteds = $event"
                    :initial-per-page="30"
                    :row-selectable="rowSelectable"
                    :fields="fields">
                        <template #additional-actions>
                            <div class="row">
                                <div class="col-auto">
                                    <v-executer variant="success" :loading="loading" :action="dateControlForInstallment" :disabled="selecteds.length == 0">
                                        ({{selecteds.length}}) ({{ totalSelected }}₺) Seçilen Faturalar İçin Ödeme Oluştur
                                    </v-executer>
                                </div>
                                <div class="d-flex  justify-content-end">
                                    <v-executer :loading="filterLoading" :variant="success" :action="exportReport">Excel'e Aktar</v-executer>
                                </div>
                            </div>
                        </template>
                    </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { NetsisApi } from '@/api/netsis'
import { PaymentApi } from '@/api/payment'
export default {
    components:{
        BCard
    },
    data(){
        return{
            loading:false,
            fields:[
                { name:"Cari Adı",key:'CustomerName', tdClass:'text-nowrap',thClass:'w-20'},
                { name:"Durum",key:'PaymentPoolStatusStr',thClass:'w-5', tdClass:'text-nowrap',component:true, componentOptions:{ name:'quick-payment-installment/QuickPaymentInstallmentStatus' }},
                { name:"Güneş Faturası Mı?",key:'IsSunProduct',thClass:'w-5', tdClass:'text-nowrap'},
                { name:"Plasiyer",key:'PlasiyerKodu',thClass:'w-5', tdClass:'text-nowrap'},
                { name:"Gör. Sayısı",key:'ClickCount',thClass:'w-6', tdClass:'text-nowrap'},
                { name:"Ref. Kodu",key:'GroupCode',thClass:'w-7', tdClass:'text-nowrap',component:true, componentOptions:{ name:'customer/CustomerPaymentLink' }},
                { name:"Cari Kod",key:'CustomerCode', tdClass:'text-nowrap',thClass:'w-5'},
                { name:"Belge No",key:'BelgeNo', tdClass:'text-nowrap',thClass:'w-15'},
                { name:"Tarih",key:'Tarih',thClass:'w-5', tdClass:'text-nowrap'},
                { name:"Son Taks. Tarihi",key:'InstallmentLastDay',thClass:'w-6', tdClass:'text-nowrap'},
                { name:"Vade Tarihi",key:'VadeTarihi',thClass:'w-5', tdClass:'text-nowrap'},
                { name:"Kalan Borç (TL)",key:'KalanBorcStr', tdClass:'text-nowrap text-right',thClass:'w-5',component:true, componentOptions:{ name:'customer/CustomerDebt' }, key:'KalanBorcStr', tdClass:'text-nowrap text-right'},
                { name:"Borç (TL)",key:'BorcStr',thClass:'w-5', tdClass:'text-nowrap'},
                { name:"Kapatılmış Tutar (TL)",key:'KapatilmisTutarStr',thClass:'w-5', tdClass:'text-nowrap text-right'},
                { name:"Açıklama",key:'Aciklama',thClass:'w-9', tdClass:'text-nowrap'},
                { name:"Hareket Türü",key:'HareketTuru', tdClass:'text-nowrap',thClass:'w-5'},
            ],
            selecteds:[],
            items:[]
        }
    },
    mounted(){
        this.getItems()
    },
    methods:{
        rowSelectable(item,items){
            return item.IsPayable && (item.PaymentPoolStatus == null || item.PaymentPoolStatus == 4 || item.PaymentPoolStatus == 1 || item.PaymentPoolStatus == 2) 
        }, 
        getItems(){
            this.$refs.table.setLoading(true)
            NetsisApi.CanBeInstallmentWithoutApprove().then(res=>{
                this.items = res.data.Data
                this.$refs.table.setLoading(false)
            }).catch(err=>{
                this.$refs.table.setLoading(true)
            })
        },
        getReport(){
            this.filterLoading = true
           
            NetsisApi.CanBeInstallmentWithoutApprove(this.requestData).then(res => {
                this.filterLoading = false
                this.reportData = res.data.Data
            }).catch(err=>{
                this.filterLoading = false
            })
        },
        exportReport(){
            this.getReport()
            this.filterLoading = true
           
           NetsisApi.GetTaksitYapilabilirOdemelerReportExcel(this.requestData).then(res => {
               this.filterLoading = false
               this.$result(res)
           }).catch(err=>{
               this.filterLoading = false
           })
        },
        
        dateControlForInstallment(){
            this.loading = true
            let controlData = this.selecteds.map((c) => {
                return {
                    Tutar:c.KalanBorc,
                    Tarih:c.Tarih,
                    CariCode:c.CariKod,
                    DocumentNo:c.BelgeNo,
                    VadeTarihi:c.VadeTarihi
                }
            })
            PaymentApi.DateControlForInstallment(controlData).then(res => {
                const data=res.data.Data
                if(!res.data.Success){
                    this.$result(res)
                    this.loading =false
                }
                if(res.data.Success){

                    // 1- Seçili tüm faturalar güneş faturası olduğu durumlar ve Seçili tüm faturaların vade tarihi geçmiş olabilir | Bu durumda direkt olarak ödeme taksit olmadan ödeme alınması söz konusudur.
                    if(!data.JanuaryControl && data.SunCampaignProductControl && !data.IsCanBeInstallment && data.SunCampaignProductMessage != null){
                    this.$confirm('Ödeme İşlemi Onayı',`${data.SunCampaignProductMessage} faturalarına ait vade tarihi geçmiş ödemeler mevcut. Bu faturalara taksit yapılamaz. Onaylıyor musunuz?`,"Tek Çekim").then(result=>{
                        if(result){
                            PaymentApi.CreatePaymentRequest(controlData).then(res => {
                                this.$result(res)
                                this.selecteds =[]
                                
                                this.getItems()
                                this.loading =false
                            })
                        }else{
                            this.getItems()
                            this.loading =false
                            this.selecteds =[]
                        }
                    })   
                    }
                    // 3- Seçili tüm faturalar güneş faturası olduğu durumlar ve Seçili faturaların hiçbirinin vade tarihi geçmemiş olabilir
                    if(!data.JanuaryControl && data.SunCampaignProductControl && data.IsCanBeInstallment && data.SunCampaignProductMessage == null){
                    this.$confirm('Ödeme İşlemi Onayı',`Seçili faturaların tamamı Güneş ürünlerini içermektedir. İşletmenizin kuralları gereği ilgili faturalara vade tarihi geçmediği için taksit yapılabilir. Onaylıyor musunuz?`,"Taksit").then(result=>{
                        if(result){
                            PaymentApi.CreatePaymentRequest(controlData).then(res => {
                                this.$result(res)
                                this.selecteds =[]
                                
                                this.getItems()
                                this.loading =false
                            })
                        }else{
                            this.getItems()
                            this.loading =false
                            this.selecteds =[]
                        }
                    })   
                    }


                    if(!data.SunCampaignProductControl && data.JanuaryControl && data.IsCanBeInstallment && data.JanuaryControlCheck!= null){
                    this.$confirm('Ödeme İşlemi Onayı',`Seçilen ${this.selecteds.length > 1 ? 'faturalar':'fatura'} için Ocak ve Şubat ayı kontrolü geçerlidir. Taksitli şekilde ödeme yapılabilir. Müşteriye ödeme bilgilendirmesi taksit seçenekleri ile birlikte sunulacaktır. Onaylıyor musunuz?`,"Taksit").then(result=>{
                        if(result){
                            PaymentApi.CreatePaymentRequest(controlData).then(res => {
                                this.$result(res)
                                this.selecteds =[]
                                
                                this.getItems()
                                this.loading =false
                            })
                        }else{
                            this.getItems()
                            this.loading =false
                            this.selecteds =[]
                        }
                    })                        
                    }

                    if(!data.SunCampaignProductControl && !data.JanuaryControl && data.NotPaidInvoicesBeforeDueDate != null && data.NotPaidInvoicesBeforeDueDate.length>0 && data.IsHaveNotPaidInvoicesBeforeDueDate && !data.IsCanBeInstallment ){
                    let invoices = data.NotPaidInvoicesBeforeDueDate.map(i=>i.DocumentNo).join(', ')
                    this.$confirm('Ödeme İşlemi Onayı',`Seçilen ${this.selecteds.length > 1 ? 'faturalar':'fatura'} için işletme kurallarınız gereği  müşterinin öncelikli olarak ödemesi gereken, vade tarihini aşan faturaların numarası şu şekildedir: ${invoices}. Sistem bu faturalara sadece tek çekim üzerinden ödeme bilgisi gönderebilir. Onaylıyor musunuz?` ,"Tek Çekim").then(result=>{
                        if(result){
                            PaymentApi.CreatePaymentRequest(data.NotPaidInvoicesBeforeDueDate).then(res => {
                                this.$result(res)
                                this.selecteds =[]
                                
                                this.getItems()
                                this.loading =false
                            })
                        }else{
                            this.getItems()
                            this.loading =false
                            this.selecteds =[]
                        }
                    })
                    }


                    if(!data.SunCampaignProductControl && !data.JanuaryControl &&data.IsLowerInstallmentLimitRule && !data.IsHaveNotPaidInvoicesBeforeDueDate){
                    this.$confirm('Ödeme İşlemi Onayı',`Seçilen ${this.selecteds.length > 1 ? 'faturalar':'fatura'} için işletme kurallarınız gereği ${data.LowerInstallmentLimit} ₺ tutarının altındaki tutarlara taksit yapılamaz. Ödeme bilgisi müşteriye tek çekim üzerinden gönderilecektir. Onaylıyor musunuz?` ,"Tek Çekim").then(result=>{
                        if(result){
                            PaymentApi.CreatePaymentRequest(controlData).then(res => {
                                this.$result(res)
                                this.selecteds =[]
                                
                                this.getItems()
                                this.loading =false
                            })
                        }else{
                            this.getItems()
                            this.loading =false
                            this.selecteds =[]
                        }
                    })
                    }
                    if(!data.SunCampaignProductControl && !data.JanuaryControl &&data.IsCanBeInstallment && !data.IsLowerInstallmentLimitRule && !data.IsHaveNotPaidInvoicesBeforeDueDate){
                    this.$confirm('Ödeme İşlemi Onayı',`Seçilen ${this.selecteds.length > 1 ? 'faturalar':'fatura'} için ortalama vade gün sayısı ${data.AvarageDate} gündür. Taksitli şekilde ödeme yapılabilir. Müşteriye ödeme bilgilendirmesi taksit seçenekleri ile birlikte sunulacaktır. Onaylıyor musunuz?`,"Taksit").then(result=>{
                        if(result){
                            PaymentApi.CreatePaymentRequest(controlData).then(res => {
                                this.$result(res)
                                this.selecteds =[]
                                
                                this.getItems()
                                this.loading =false
                            })
                        }else{
                            this.getItems()
                            this.loading =false
                            this.selecteds =[]
                        }
                    })
                    }
                    if(!data.SunCampaignProductControl && !data.JanuaryControl &&!data.IsCanBeInstallment && !data.IsLowerInstallmentLimitRule && !data.IsHaveNotPaidInvoicesBeforeDueDate){
                    this.$confirm('Ödeme İşlemi Onayı',`Seçilen ${this.selecteds.length > 1 ? 'faturaların':'faturanın'} ortalama vade gün sayısı ${data.AvarageDate} gündür. İşletmenizin kuralları gereği seçilen ${this.selecteds.length > 1 ? 'faturalara':'faturaya'} ait taksitlendirme işlemi gerçekleştirilemez. Eğer taksitlendirme işlemi gerçekleştirmek istiyorsanız bunu yöneticiniz onayı ile yapmak zorundasınız. Onaylıyor musunuz?`).then(result=>{
                        if(result){
                            this.$confirm('Taksit Onay','Bu ödeme işlemi için taksitlendirme yapmak istiyorsanız yöneticinize onay bilgilendirmesi gidecektir.','Onay Al','Tek Çekim').then(res=>{
                                if(res == true){
                                    PaymentApi.CreateResponsibleUserApproveRequest(controlData).then(res=> {
                                        this.$result(res)
                                        this.selecteds =[]
                                        
                                        this.getItems()
                                        this.loading =false
                                    })
                                }else if(res == false){
                                    PaymentApi.CreatePaymentRequest(controlData).then(res => {
                                        this.$result(res)
                                        this.selecteds =[]
                                        
                                        this.getItems()
                                        this.loading =false
                                    })
                                }
                            })
                        }else{
                            this.getItems()
                            this.loading =false
                            this.selecteds =[]
                        }
                    })
                    }
                    }
                
            })
        }
    },
    computed:{
        c_items(){
            if(this.selecteds && this.selecteds?.length){
                let selectedCariKod = this.selecteds[0]?.CariKod
                return selectedCariKod ? this.items.filter(i=>i.CariKod == selectedCariKod ) : this.items
            }else return this.items
        },
        totalSelected(){
            let sum = this.selecteds.reduce((sum,item)=>sum += item.KalanBorc,0)
            if(sum){
                return new Intl.NumberFormat('tr-TR', {
                    currency: 'TRY',
                    minimumFractionDigits: 2,
                }).format(sum)
            }else return "0,00"
        }
    }
}
</script>

<style>

</style>